import React from 'react'
import blenderPng from '../images/blender.png'
import c4dPng from '../images/c4d.png'
import arnoldPng from '../images/arnold.png'
import maxPng from '../images/3ds-max.png'
import houdiniPng from '../images/houdini.png'
import vrayPng from '../images/v-ray.png'
import mayaPng from '../images/maya.png'
import unrealPng from '../images/unreal-engine.png'
import nukePng from '../images/nuke.png'

const ICON_SIZE = 20

type SolutionIconProps = React.ImgHTMLAttributes<HTMLImageElement>

const makeSolutionIcon = (src: string, alt: string) =>
  function SolutionIcon(props: SolutionIconProps) {
    return <img src={src} alt={alt} width={ICON_SIZE} height={ICON_SIZE} {...props} />
  }

export const BlenderSolutionIcon = makeSolutionIcon(blenderPng, 'Blender')
export const C4DSolutionIcon = makeSolutionIcon(c4dPng, 'Cinema 4D')
export const ArnoldSolutionIcon = makeSolutionIcon(arnoldPng, 'Arnold')
export const MaxSolutionIcon = makeSolutionIcon(maxPng, '3ds Max')
export const HoudiniSolutionIcon = makeSolutionIcon(houdiniPng, 'Houdini')
export const VRaySolutionIcon = makeSolutionIcon(vrayPng, 'V-Ray')
export const MayaSolutionIcon = makeSolutionIcon(mayaPng, 'Maya')
export const UnrealSolutionIcon = makeSolutionIcon(unrealPng, 'Unreal Engine')
export const NukeSolutionIcon = makeSolutionIcon(nukePng, 'Nuke')
